import { render } from "./layerWaterFootprint.vue?vue&type=template&id=3455795a&ts=true"
import script from "./layerWaterFootprint.vue?vue&type=script&lang=ts"
export * from "./layerWaterFootprint.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__